import Vue from 'vue'
import VueRouter from 'vue-router'
// import axios from 'axios'

const routes = require('./routes')

Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach(async (to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title;
    to.meta.description ? document.querySelector('meta[name="description"]').setAttribute("content", to.meta.description) : '';
    to.meta.description ? document.querySelector('meta[property="og:description"]').setAttribute("content", to.meta.description) : '';
    to.meta.title ? document.querySelector('meta[name="title"]').setAttribute("content", to.meta.title) : '';
    to.meta.title ? document.querySelector('meta[property="og:title"]').setAttribute("content", to.meta.title) : '';
      // document.querySelector('meta[property="og:image"]').setAttribute("content", "https://storage.yandexcloud.net/wildwood/brand/like.jpg");
  });
})
// router.beforeEach(async (to, from, next) => {
  
//   const requireAuth = to.matched.some(forum => forum.meta.auth);
//   const requireAdmin = to.matched.some(forum => forum.meta.admin);
//   if (requireAuth || requireAdmin) {
//     let token = localStorage.getItem('token');

//     if (token) {
//       // this.$store.dispatch('setLoader', {element: 'general', val: true})
//       await axios.post(`/api/auth/session`, {}, {
//         headers: {
//           'Authorization': `${token}`
//         }
//       })
//         .then((response) => {
//           response.status === 200 && response.statusText === 'OK' ? next() : next('/login')
//         })
//     } else {
//       next('/login')
//     }
//   } else {
//     next()
//   }
// })

export default router
